export default "__VITE_ASSET__b9d7a518__"